import { UploadDetails } from './upload-details';

export { UploadDetails };
